// Whatsapp integration utility functions

export const sendInvoiceViaWhatsApp = (invoice, clientPhone) => {
  // Validate phone number exists
  if (!clientPhone) {
    alert('Client phone number not available. Please add it in client details.');
    return false;
  }

  // Clean phone number
  const cleanPhone = clientPhone.replace(/[^0-9]/g, '');
  
  if (cleanPhone.length < 10) {
    alert('Invalid phone number. Please update client phone number.');
    return false;
  }

  const phoneWithCode = cleanPhone.startsWith('91') ? cleanPhone : `91${cleanPhone}`;
  
  // Generate PUBLIC invoice URL using publicId
  const invoiceUrl = `${window.location.origin}/invoice/${invoice.publicId}`;
  
  const message = `
Hello,

Your invoice from *EasyBilling* is ready!

📄 *Invoice Details:*
Invoice No: ${invoice.invoiceNumber}
Date: ${new Date(invoice.invoiceDate).toLocaleDateString('en-IN')}
Amount: ₹${invoice.grandTotal.toLocaleString()}
Payment Status: ${invoice.paymentStatus}

📎 *View Invoice:*
${invoiceUrl}

Thank you for your business!

Best regards,
EasyBilling Team
  `.trim();

  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneWithCode}?text=${encodedMessage}`;
  
  window.open(whatsappUrl, '_blank');
  
  return true;
};

export const sendPaymentReminderViaWhatsApp = (invoice, clientPhone, clientName) => {
  if (!clientPhone) {
    alert('Client phone number not available. Please add it in client details.');
    return false;
  }

  const cleanPhone = clientPhone.replace(/[^0-9]/g, '');
  
  if (cleanPhone.length < 10) {
    alert('Invalid phone number. Please update client phone number.');
    return false;
  }

  const phoneWithCode = cleanPhone.startsWith('91') ? cleanPhone : `91${cleanPhone}`;
  
  const amountDue = invoice.grandTotal - invoice.amountPaid;
  
  // Generate PUBLIC invoice URL using publicId
  const invoiceUrl = `${window.location.origin}/invoice/${invoice.publicId}`;
  
  const message = `
Hello ${clientName},

This is a friendly reminder regarding your pending payment.

📄 *Invoice Details:*
Invoice No: ${invoice.invoiceNumber}
Date: ${new Date(invoice.invoiceDate).toLocaleDateString('en-IN')}
Total Amount: ₹${invoice.grandTotal.toLocaleString()}
Amount Paid: ₹${invoice.amountPaid.toLocaleString()}
*Amount Due: ₹${amountDue.toLocaleString()}*

📎 *View Invoice:*
${invoiceUrl}

Please make the payment at your earliest convenience.

Thank you!

Best regards,
EasyBilling Team
  `.trim();

  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneWithCode}?text=${encodedMessage}`;
  
  window.open(whatsappUrl, '_blank');
  
  return true;
};